import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Location } from 'types/washhub';

export interface WashhubState {
  locations: Location[];
  selectedLocation: Location | null;
}

const initialState = {
  locations: [],
  selectedLocation: null,
} as WashhubState;

const slice = createSlice({
  name: 'washhub',
  initialState,
  reducers: {
    saveLocations: (state, action: PayloadAction<Location[]>) => {
      state.locations = action.payload;
    },
    setSelectedLocation: (state, action: PayloadAction<Location>) => {
      state.selectedLocation = action.payload;
    },
  },
});

export const WashhubActions = {
  ...slice.actions,
};

export const washhubReducer = slice.reducer;
